import loadable from "@loadable/component"
import { RouteObject } from "react-router-dom"

import { APP_ROUTES } from "~/shared/constants/routes"

const NotificationCampaignsPage = loadable(
  async () =>
    import("~/features/notification-campaigns/pages/NotificationCampaignsPage"),
  { fallback: <></> },
)

export const notificationCampaignRoutes: RouteObject[] = [
  {
    path: APP_ROUTES.notificationCampaigns,
    element: <NotificationCampaignsPage />,
  },
]
